import styled, { css } from 'styled-components'

export {
  AlertWrapper,
  StickyPreviewContainer as Container,
  PreviewContent,
} from '@/configuration/pages/ConfigurationPage/sharedStyles'

export const MethodRequestContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const SplitButtonWrapper = styled.div`
  button {
    overflow: hidden;
  }

  ${props =>
    props.isSelected &&
    css`
      button {
        border-color: ${props => props.theme.splitButton.selected.borderColor} !important;
        color: ${props => props.theme.splitButton.selected.color} !important;
      }

      button > div:first-child {
        background-color: ${props => props.theme.splitButton.selected.backgroundColor} !important;

        svg {
          fill: ${props => props.theme.splitButton.selected.iconColor} !important;
        }
      }
    `}
`

export const DeliveryMethodWrapper = styled.div`
  & > div {
    margin-top: 0;
    padding-bottom: 0;
  }

  & > div > div > div {
    margin-bottom: 0;
  }
`

export const VariantsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacing.sp8};
`

export const RefundIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${props => props.theme.primitives.radius.radius6};
  background-color: ${props => props.theme.splitButton.backgroundColor};
  padding: ${props => props.theme.spacing.sp8};
  transition: all ease 0.4s;

  svg {
    color: ${props => props.theme.splitButton.iconColor};
    fill: ${props => props.theme.splitButton.iconColor};

    path {
      fill: ${props => props.theme.splitButton.iconColor};
    }
  }
`

export const TotalAmountContainer = styled.div`
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.splitButton.borderColor};
  width: calc(100%);
  margin-left: -${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius0} ${props => props.theme.primitives.radius.radius0}
    ${props => props.theme.primitives.radius.radius4} ${props => props.theme.primitives.radius.radius4};
  background-color: ${props => props.theme.splitButton.backgroundColor};
  color: ${props => props.theme.splitButton.iconColor};
  transition: all ease 0.4s;
`

export const RefundOptionTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${props => props.theme.splitButton.color};
  gap: ${props => props.theme.spacing.sp8};
`

export const RefundOptionChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacing.sp8};
`

export const RefundOptionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  font-weight: 600;
  font-size: ${props => props.theme.texts.titleS.fontSize};
  font-family: ${props => props.theme.texts.titleS.fontFamily};
  color: ${props => props.theme.splitButton.color};

  p {
    user-select: none;
    margin: 0;
  }
`

export const HelperText = styled.p`
  color: ${props => props.theme.splitButton.color};
  user-select: none;
  padding-bottom: ${props => props.theme.spacing.sp8};
  margin: 0;
  font-family: ${props => props.theme.texts.bodyMRegular.fontFamily};
  font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
  line-height: ${props => props.theme.texts.bodyMRegular.lineHeight};
  transition: all ease 0.4s;
`

export const RefundOption = styled.div`
  border-radius: ${props => props.theme.primitives.radius.radius4};
  padding: ${props => props.theme.spacing.sp16};
  padding-bottom: 0;
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.splitButton.borderColor};
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  user-select: none;
  cursor: pointer;
  transition: all ease 0.4s;

  ${props =>
    props.isSelected &&
    css`
      border-color: ${props => props.theme.splitButton.selected.borderColor} !important;
      color: ${props => props.theme.splitButton.selected.color} !important;

      & > p {
        color: ${props => props.theme.splitButton.selected.iconColor} !important;
      }

      ${RefundIconContainer} {
        background-color: ${props => props.theme.splitButton.selected.backgroundColor} !important;

        svg {
          color: ${props => props.theme.splitButton.selected.iconColor} !important;
          fill: ${props => props.theme.splitButton.selected.iconColor} !important;

          path {
            fill: ${props => props.theme.splitButton.selected.iconColor} !important;
          }
        }
      }

      ${TotalAmountContainer} {
        background-color: ${props => props.theme.splitButton.selected.backgroundColor} !important;
        color: ${props => props.theme.splitButton.selected.iconColor} !important;
        border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle} !important;
      }

      ${RefundOptionTitleContainer} {
        & > p {
          color: ${props => props.theme.splitButton.selected.color} !important;
        }
      }

      ${HelperText} {
        color: ${props => props.theme.splitButton.selected.color} !important;
      }
    `}

  &:hover {
    border-color: ${props => props.theme.splitButton.hover.borderColor};
    color: ${props => props.theme.splitButton.hover.color};

    p {
      color: ${props => props.theme.splitButton.hover.iconColor};
    }

    ${RefundIconContainer} {
      background-color: ${props => props.theme.splitButton.hover.backgroundColor};

      svg {
        color: ${props => props.theme.splitButton.hover.iconColor};
        fill: ${props => props.theme.splitButton.hover.iconColor};

        path {
          fill: ${props => props.theme.splitButton.hover.iconColor};
        }
      }
    }

    ${TotalAmountContainer} {
      background-color: ${props => props.theme.splitButton.hover.backgroundColor};
      color: ${props => props.theme.splitButton.hover.iconColor};
      border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
    }

    ${RefundOptionTitleContainer} {
      & > p {
        color: ${props => props.theme.splitButton.hover.color};
      }
    }

    ${HelperText} {
      color: ${props => props.theme.splitButton.hover.color} !important;
    }
  }
`
